<template>
  <div class="site-map">
    <div class="site-map__container">
      <nav class="site-map__breadcrumbs" aria-label="Хлебные крошки">
        <ol>
          <li>
            <router-link to="/">Главная</router-link>
            <img src="@/assets/svg/arrow-mini.svg" alt="" />
          </li>
          <li>
            <span aria-current="page">Карта сайта</span>
          </li>
        </ol>
      </nav>

      <h1 class="site-map__title">Карта сайта</h1>
      <p class="site-map__lead">
        Структура разделов сайта — так же, как в меню. Все названия ведут на соответствующие страницы.
      </p>

      <div v-if="isLoading && !tree.length" class="site-map__loading">Загрузка…</div>
      <ul v-else-if="tree.length" class="site-map__tree" role="list">
        <sitemap-node
          v-for="(item, index) in tree"
          :key="item.id || item.to || index"
          :item="item"
        />
      </ul>
      <p v-else class="site-map__empty">Разделы меню пока не загрузились.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionTypes } from '@/store/modules/menuItems'
import SitemapNode from './SitemapNode.vue'

export default {
  name: 'AppSitemap',
  components: { SitemapNode },
  metaInfo() {
    return {
      title: 'Карта сайта | Алтайский краевой клинический перинатальный центр ДАР',
      meta: [
        {
          name: 'description',
          content: 'Карта сайта перинатального центра ДАР: разделы и страницы в виде дерева меню.',
        },
      ],
    }
  },
  computed: {
    ...mapState('menuItems', {
      menuItems: (state) => state.menuItems,
      isLoading: (state) => state.isLoading,
    }),
    tree() {
      return Array.isArray(this.menuItems) ? this.menuItems : []
    },
  },
  mounted() {
    this.$store.dispatch(`menuItems/${actionTypes.loadMenuItems}`)
  },
}
</script>

<style lang="scss">
.site-map {
  width: 100%;
  background: #fff;
  padding-bottom: 72px;
}

.site-map__container {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 20px 24px;
}

.site-map__breadcrumbs {
  padding: 16px 0 8px;

  ol {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: "Circe", sans-serif;
    font-size: 14px;
    color: #8a8a8a;
  }

  a {
    color: #8a8a8a;
    text-decoration: none;

    &:hover {
      color: #66cc66;
    }
  }

  img {
    width: 10px;
    height: 10px;
    opacity: 0.6;
  }
}

.site-map__title {
  margin: 12px 0 10px;
  font-family: "TTDrugs", "Circe", sans-serif;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
  color: #2d5a27;
  text-transform: uppercase;
}

.site-map__lead {
  margin: 0 0 28px;
  max-width: 640px;
  font-family: "Circe", sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #555;
}

.site-map__loading,
.site-map__empty {
  font-family: "Circe", sans-serif;
  color: #666;
}

.site-map__tree {
  list-style: none;
  margin: 0;
  padding: 0;
}

.site-map__tree--nested {
  margin: 8px 0 4px;
  padding-left: 22px;
  border-left: 2px solid #e4efe4;
}

.site-map__node {
  margin: 0 0 10px;
}

.site-map__link,
.site-map__label {
  font-family: "Circe", sans-serif;
  font-size: 18px;
  line-height: 1.4;
  color: #222;
}

.site-map__link {
  text-decoration: none;
  border-bottom: 1px solid transparent;

  &:hover {
    color: #2d5a27;
    border-bottom-color: #66cc66;
  }
}

.site-map__tree > .site-map__node > .site-map__link,
.site-map__tree > .site-map__node > .site-map__label {
  font-family: "TTDrugs", "Circe", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #2d5a27;
}

@media (max-width: 720px) {
  .site-map__title {
    font-size: 28px;
  }

  .site-map__link,
  .site-map__label {
    font-size: 16px;
  }
}
</style>
